import { faPaintbrushPencil } from '@fortawesome/pro-solid-svg-icons';

import { ControlPanelButton, ControlPanelButtonTooltip, IconMenuItem } from '../../components';

export function WhiteboardControl({
  isWhiteboardMode,
  isLoading,
  onClick,
}: {
  isWhiteboardMode: boolean;
  isLoading?: boolean;
  onClick: () => void;
}) {
  const label = isWhiteboardMode ? 'Close whiteboard' : 'Open whiteboard';

  return (
    <div className='hidden md:block'>
      <ControlPanelButtonTooltip text={label} childIsInteractive>
        <ControlPanelButton
          aria-label={label}
          loading={isLoading}
          iconDefinition={faPaintbrushPencil}
          data-testid='whiteboard-control'
          onClick={onClick}
        />
      </ControlPanelButtonTooltip>
    </div>
  );
}

export function WhiteboardControlMenuItem({
  isWhiteboardMode,
  onClick,
  isLoading,
}: {
  isWhiteboardMode: boolean;
  onClick: () => void;
  isLoading?: boolean;
}) {
  return (
    <IconMenuItem loading={isLoading} aria-expanded={isWhiteboardMode} onClick={onClick} icon={faPaintbrushPencil}>
      <span>{isWhiteboardMode ? 'Close' : 'Open'} whiteboard</span>
    </IconMenuItem>
  );
}
